import { useQuery } from '@tanstack/react-query'

import { type CampaignListRow, getCampaignsQuery } from 'models/campaigns-model'
import { get } from 'utils/http'

// Campaigns list; rows used raw (snake_case, no derived values). `enabled` gates on login.
export const useCampaigns = (meta: any, enabled: boolean) =>
  useQuery({
    queryKey: ['campaigns', meta],
    queryFn: async () => {
      const { campaigns, count } = await get<{ campaigns: CampaignListRow[]; count: number }>(
        `/management/campaigns?${getCampaignsQuery(meta)}`,
      )
      return { count, items: campaigns || [] }
    },
    enabled,
  })
